import JSONApiService from "@/services/JSONApiService";
import { TALENT_POOL_MODEL } from "@/models/talent-pool-model";
import APIService from "@/services/APIService";
import pluralize from "pluralize";

import {
  include,
  USERS,
  nested,
  APPLICATIONS,
  INTERVIEW_SLOTS,
  OFFERS
} from "@/models/relationships";

const talentPoolIncludes = include(
  USERS,
  nested(USERS, APPLICATIONS),
  nested(USERS, INTERVIEW_SLOTS),
  nested(USERS, OFFERS)
);

const talentPoolsApi = ({ commit } = {}) => ({
  getTalentPools: async params =>
    JSONApiService(commit)
      .all(TALENT_POOL_MODEL)
      .get({ ...params, ...include(USERS) }),
  addTalentPool: async data =>
    JSONApiService(commit)
      .all(TALENT_POOL_MODEL)
      .post(data),
  addUsersToTalentPool: async (id, users) =>
    APIService.client().post(`${pluralize(TALENT_POOL_MODEL)}/${id}/${USERS}`, {
      data: { attributes: { users } }
    }),
  getTalentPool: async id =>
    JSONApiService(commit).find(TALENT_POOL_MODEL, id, talentPoolIncludes),
  editTalentPool: async (id, data) =>
    JSONApiService(commit)
      .one(TALENT_POOL_MODEL, id)
      .patch(data, talentPoolIncludes),
  deleteTalentPool: async id =>
    JSONApiService(commit)
      .one(TALENT_POOL_MODEL, id)
      .destroy()
});

export default talentPoolsApi;
